import styled, { css } from 'styled-components';
import { ForwardedRef, forwardRef, RefObject } from 'react';

import {
  Button,
  StyledSection,
  ArticleWrapper,
  ContentContainer,
} from '@components/atoms';
import useDevice from '@hooks/useDevice';
import { Article, SectionHeader } from '@components/molecules';
import { FeedbackDesktop, FeedbackMobile } from '@components/organisms';
import { Feedback as FeedbackType } from '@shared/constants/feedback';
import Rocket from '@public/icons/rocket.svg';
import { device } from '@styles/mediaQuery';
import { scrollTo } from '@utils/scrollTo';

type FeedbackProps = { content: FeedbackType[] };

function Feedback(
  { content }: FeedbackProps,
  ref: ForwardedRef<HTMLDivElement | null>
) {
  const { isMobile, isTablet } = useDevice();
  const isPortable = isMobile || isTablet;

  const onButtonClick = () => {
    scrollTo(ref as RefObject<HTMLDivElement>, 'contacts');
  };

  return (
    <CustomStyledSection>
      <ContentContainer>
        <SectionHeader title="Feedback" src="icons/feedback.svg" />

        <ArticleWrapper margin="0 0 24px">
          <Article
            align="center"
            titleMaxWidth="450px"
            descriptionMaxWidth="750px"
            wrapAlign="center"
            wrapWidth="100%"
            title="What Our Customers Are Saying"
            description={
              !isPortable
                ? 'We are dedicated to your success, prioritizing your needs by delivering exceptional experiences, timely solutions, and unwavering support - because your goals are our mission.'
                : ''
            }
          />
        </ArticleWrapper>
      </ContentContainer>

      <FeedbackDesktop content={content} />
      <FeedbackMobile content={content} />

      <ButtonWrapper>
        <Button
          height="48px"
          width="243px"
          color="white"
          title="Get Started"
          bgColor="textPrimary"
          onClick={onButtonClick}
          Icon={Rocket}
        />
      </ButtonWrapper>
    </CustomStyledSection>
  );
}

const CustomStyledSection = styled(StyledSection)`
  margin-bottom: 150px;
`;

const ButtonWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;

  ${device.laptopL(css`
    margin-top: 0;
  `)}
`;

export default forwardRef<HTMLDivElement | null, FeedbackProps>(Feedback);
